import { Help_contactCta, Common_loading, Help_fallbackNotice, Help_close, Help_title, Help_nextChapter, Help_prevChapter, Help_chapter07, Help_chapter06, Help_chapter05, Help_chapter04, Help_chapter03, Help_chapter02, Help_chapter01, Help_chapterIndex } from "../Shared/Tr.js";
import { length, item, tryFindIndex, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { ofNullable, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { empty, append, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { t as t_1 } from "../Lang.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";

const chapters = ofArray([["index", Help_chapterIndex], ["01", Help_chapter01], ["02", Help_chapter02], ["03", Help_chapter03], ["04", Help_chapter04], ["05", Help_chapter05], ["06", Help_chapter06], ["07", Help_chapter07]]);

function chapterIndex(chapterId) {
    return defaultArg(tryFindIndex((tupledArg) => (tupledArg[0] === chapterId), chapters), 0);
}

function prevChapter(chapterId) {
    const idx = chapterIndex(chapterId) | 0;
    if (idx > 0) {
        return item(idx - 1, chapters)[0];
    }
    else {
        return undefined;
    }
}

function nextChapter(chapterId) {
    const idx = chapterIndex(chapterId) | 0;
    if (idx < (length(chapters) - 1)) {
        return item(idx + 1, chapters)[0];
    }
    else {
        return undefined;
    }
}

function chapterNav(currentChapter, dispatch) {
    let elems;
    return createElement("nav", createObj(ofArray([["className", "help-chapter-nav"], (elems = toList(delay(() => collect((matchValue) => {
        const id = matchValue[0];
        return singleton(createElement("button", {
            className: (id === currentChapter) ? "help-chapter-link active" : "help-chapter-link",
            children: t_1(matchValue[1]),
            onClick: (_arg) => {
                dispatch(new Msg(272, [id]));
            },
        }));
    }, chapters))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function chapterFooterNav(currentChapter, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "help-footer-nav"], (elems = toList(delay(() => {
        let matchValue, prevId;
        return append((matchValue = prevChapter(currentChapter), (matchValue == null) ? singleton(defaultOf()) : ((prevId = matchValue, singleton(createElement("button", {
            className: "btn btn-sm btn-secondary",
            onClick: (_arg) => {
                dispatch(new Msg(272, [prevId]));
            },
            children: t_1(Help_prevChapter),
        }))))), delay(() => {
            const matchValue_1 = nextChapter(currentChapter);
            if (matchValue_1 == null) {
                return singleton(defaultOf());
            }
            else {
                const nextId = matchValue_1;
                return singleton(createElement("button", {
                    className: "btn btn-sm btn-primary",
                    onClick: (_arg_1) => {
                        dispatch(new Msg(272, [nextId]));
                    },
                    children: t_1(Help_nextChapter),
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * The slide-out help panel component
 */
export function View(viewInputProps) {
    let elems_4, elems_3, elems, elems_2;
    const dispatch = viewInputProps.dispatch;
    const panel = viewInputProps.panel;
    const contentRef = reactApi.useRef(undefined);
    useEffectWithDeps(() => {
        const matchValue = panel.ScrollToId;
        const matchValue_1 = contentRef.current;
        let matchResult, anchorId, el;
        if (matchValue != null) {
            if (matchValue_1 != null) {
                matchResult = 0;
                anchorId = matchValue;
                el = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const timeoutId = window.setTimeout(() => {
                    const target = ofNullable(el.querySelector(`#${anchorId}`));
                    if (target == null) {
                    }
                    else {
                        const t = target;
                        t.scrollIntoView({
                            behavior: "instant",
                            block: "start",
                        });
                    }
                }, 200);
                return {
                    Dispose() {
                        window.clearTimeout(timeoutId);
                    },
                };
            }
            default:
                return {
                    Dispose() {
                    },
                };
        }
    }, [panel.Content, panel.ScrollToId]);
    useEffectWithDeps(() => {
        const handler = (e) => {
            const ke = e;
            if (ke.key === "Escape") {
                dispatch(new Msg(269, []));
            }
        };
        document.addEventListener("keydown", handler);
        return {
            Dispose() {
                document.removeEventListener("keydown", handler);
            },
        };
    }, [panel.IsOpen]);
    if (!panel.IsOpen) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(ofArray([["className", "help-overlay"], ["onClick", (_arg) => {
            dispatch(new Msg(269, []));
        }], (elems_4 = [createElement("div", createObj(ofArray([["className", "help-panel"], ["onClick", (e_1) => {
            e_1.stopPropagation();
        }], (elems_3 = [createElement("div", createObj(ofArray([["className", "help-panel-header"], (elems = [createElement("h3", {
            children: t_1(Help_title),
        }), createElement("button", {
            className: "help-close-btn",
            onClick: (_arg_1) => {
                dispatch(new Msg(269, []));
            },
            children: t_1(Help_close),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), chapterNav(panel.Chapter, dispatch), createElement("div", createObj(ofArray([["className", "help-panel-content"], ["ref", (el_1) => {
            if (!(el_1 == null)) {
                contentRef.current = el_1;
            }
        }], (elems_2 = toList(delay(() => append(panel.IsFallback ? singleton(createElement("div", {
            className: "help-fallback-notice",
            children: t_1(Help_fallbackNotice),
        })) : empty(), delay(() => append(panel.IsLoading ? singleton(createElement("div", {
            className: "help-loading",
            children: t_1(Common_loading),
        })) : empty(), delay(() => {
            let elems_1;
            return append(singleton(createElement("a", createObj(ofArray([["className", "help-contact-cta"], ["href", "#/contact"], ["onClick", (_arg_2) => {
                dispatch(new Msg(269, []));
            }], (elems_1 = [createElement("span", {
                className: "help-contact-icon",
                children: "✉",
            }), createElement("span", {
                children: t_1(Help_contactCta),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                const matchValue_3 = panel.Content;
                return (matchValue_3 == null) ? (!panel.IsLoading ? singleton(createElement("p", {
                    children: t_1(Help_title),
                })) : empty()) : append(singleton(createElement("div", {
                    className: "help-markdown-content",
                    dangerouslySetInnerHTML: {
                        __html: matchValue_3,
                    },
                })), delay(() => singleton(chapterFooterNav(panel.Chapter, dispatch))));
            }));
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
}

